/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { DocumentsItemRequestBuilderNavigationMetadata, DocumentsItemRequestBuilderRequestsMetadata, type DocumentsItemRequestBuilder } from './item/index.js';
// @ts-ignore
import { RejectionReasonsRequestBuilderRequestsMetadata, type RejectionReasonsRequestBuilder } from './rejectionReasons/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /documents
 */
export interface DocumentsRequestBuilder extends BaseRequestBuilder<DocumentsRequestBuilder> {
    /**
     * The rejectionReasons property
     */
    get rejectionReasons(): RejectionReasonsRequestBuilder;
    /**
     * Gets an item from the ApiSdk.documents.item collection
     * @param id Unique identifier of the item
     * @returns {DocumentsItemRequestBuilder}
     */
     byId(id: Guid) : DocumentsItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const DocumentsRequestBuilderUriTemplate = "{+baseurl}/documents";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const DocumentsRequestBuilderNavigationMetadata: Record<Exclude<keyof DocumentsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byId: {
        requestsMetadata: DocumentsItemRequestBuilderRequestsMetadata,
        navigationMetadata: DocumentsItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["id"],
    },
    rejectionReasons: {
        requestsMetadata: RejectionReasonsRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
